import React, { ReactElement } from 'react';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { withAuth } from 'lib/hocs/withAuth';
import EditSocietyProfile from './EditSocietyProfile';

import styles from './SocietyProfile.module.scss';

const EditProfile = (): ReactElement => {
  return (
    <>
      <Head>
        <title>Society Profile | Huzzle</title>
        <meta name="description" content="Huzzle" />
      </Head>
      <section className={styles.SocietyProfile} data-testid="SocietyProfile">
        <EditSocietyProfile />
      </section>
    </>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['committee', 'common'])),
    },
  };
}

const EditProfileWrapper = withAuth(EditProfile);

export default EditProfileWrapper;
